<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('payment') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row style="margin-bottom: 80px;">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list class="list-payment">
          <!-- <template v-if="$isEmpty(order) || order.payment_mode_id === 10"> -->
          <template v-if="isCD[0] && storeIsNotCod">
            <v-list-item
              :class="[{ 'selected_payment_method': selectedPayment[isCD[1]] ? selectedPayment[isCD[1]][0] === 0 ? true : false : false }]"
              @click="selectPayment(isCD[1], payment[isCD[1]], 0)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="$store.state.selected_type === 'DELIVERY' || $store.state.selected_type === 'OL-TAKE-AWAY'">
                    {{ $t('pay_after_receiving_the_order') }}
                  </span>
                  <span v-else>
                    {{ $t('pay_at_the_cashier') }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <div class="d-flex align-center">
                <div class="selected_payment" />
              </div>
            </v-list-item>
          </template>
          <template v-if="isOQ[0] && isNotWaroenk">
            <v-list-item
              :class="[{ 'selected_payment_method': selectedPayment[isOQ[1]] ? selectedPayment[isOQ[1]][0] === 0 ? true : false : false }]"
              @click="selectPayment(isOQ[1], payment[isOQ[1]], 0)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ isTMII ? 'QRIS' : payment[isOQ[1]].name }}
                </v-list-item-title>
              </v-list-item-content>
              <div class="d-flex align-center">
                <div class="selected_payment" />
              </div>
            </v-list-item>
          </template>
          <template v-if="isAS[0]">
            <v-list-item
              :class="[{ 'selected_payment_method': selectedPayment[isAS[1]] ? selectedPayment[isAS[1]][0] === 0 ? true : false : false }]"
              @click="selectPayment(isAS[1], payment[isAS[1]], 0)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ payment[isAS[1]].name }}
                </v-list-item-title>
              </v-list-item-content>
              <div class="d-flex align-center">
                <div class="selected_payment" />
              </div>
            </v-list-item>
          </template>
          <!-- </template> -->
          <v-expansion-panels v-model="panel_payment" class="__panel-payment-method" flat multiple>
            <template v-for="(item, idx) in payment">
              <v-expansion-panel
                v-if="checkDisabledPayment(item) && item.enabled"
                :key="idx"
                :disabled="item.enabled === 0 || item.detail.length === 0 ? true : false"
              >
                <v-expansion-panel-header>
                  <template>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <div class="d-flex">
                          <div class="d-block">
                            <div class="d-flex align-center">
                              <span class="d-flex __title-payment-method">
                                {{ item.name }}
                              </span>
                            </div>
                            <div v-if="item.code === 'BT' && $store.state.selected_outlet.setting.active_minimum_payment_amount_va && ($store.state.selected_type === 'DELIVERY' && dataInCart.shipping_delivery_type === 2 ? dataInCart.total_amount_without_shipping : dataInCart.total_amount) < Number($store.state.selected_outlet.setting.minimum_payment_amount_va)" class="mt-1 subtitle-2 red--text">
                              {{ $t('minimum_payment') }} <span v-mask-money="Number($store.state.selected_outlet.setting.minimum_payment_amount_va)" /> {{ $t('does_not_include_shipping_costs') }}
                            </div>
                          </div>
                          <v-spacer />
                          <div v-if="item.enabled === 0 || item.detail.length === 0" class="d-flex align-center">
                            <div class="tag-coming-soon">
                              coming soon
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:actions>
                    <v-icon color="secondary">
                      $expand
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list class="list-wallet-payment">
                    <template v-for="(child, index) in item.detail">
                      <v-list-item
                        :key="index + 'child'"
                        :class="[{ 'selected_payment_method': selectedPayment[idx] ? selectedPayment[idx][0] === index ? true : false : false }]"
                        :disabled="vaCheckEnable(child, item.code)"
                        @click="selectPayment(idx, child, index, item)"
                      >
                        <v-list-item-avatar size="30">
                          <v-img :src="child.image" contain />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ child.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="child.code === 'ShopeePay' && !$vuetify.breakpoint.smAndDown" class="caption">
                            {{ $t('only_for_mobile') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <div class="d-flex align-center">
                          <div class="selected_payment" />
                        </div>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </v-expansion-panels>
          <template v-if="isCC[0]">
            <v-list-item
              :disabled="payment[isCC[1]].enabled === 1 ? false : true"
              :class="[{ 'selected_payment_method': selectedPayment[isCC[1]] ? selectedPayment[isCC[1]][0] === 0 ? true : false : false }]"
              @click="selectPayment(isCC[1], payment[isCC[1]], 0)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ payment[isCC[1]].name }}
                </v-list-item-title>
              </v-list-item-content>
              <div class="d-flex align-center">
                <div class="selected_payment" />
              </div>
            </v-list-item>
          </template>
        </v-list>
      </v-col>
    </v-row>

    <v-bottom-sheet v-model="dialogPhone" persistent content-class="showFull">
      <v-sheet style="height: 100%">
        <ValidationObserver ref="observerEWallet" v-slot="{ invalid, validated, passes, validate }">
          <v-form id="formPay" @submit.prevent="payLinkAja()">
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <div class="d-flex">
                    <h2 class="headline">
                      <span class="font-weight-bold d-flex align-center">
                        {{ $t('payment') }}
                      </span>
                    </h2>
                    <v-spacer />
                    <v-btn text icon color="red lighten-2" @click="closeDialogPhone">
                      <v-icon>
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: 80px;">
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <v-card class="mx-auto __card-shadow">
                    <v-card-text class="pa-4">
                      <div class="d-flex">
                        <h5 class="subtitle-1 font-weight-bold text--primary">
                          Total
                        </h5>
                        <v-spacer />
                        <h5 v-mask-money="dataInCart.total_amount" class="subtitle-1 font-weight-bold text--primary" />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <v-card class="mx-auto __card-shadow">
                    <v-card-text class="pa-4">
                      <div class="d-flex">
                        <h5 class="subtitle-1 font-weight-bold text--primary">
                          {{ selectedTypePay.name }}
                        </h5>
                        <v-spacer />
                        <v-img :src="selectedTypePay.image" height="24" width="24" max-height="24" max-width="24" contain />
                      </div>
                      <hr class="my-4 __dashed">
                      <div class="d-flex flex-column">
                        <span class="font-weight-bold soft-grey--text mb-1">
                          {{ $t('enter_phonenumber') }}
                        </span>
                        <!-- <ValidationProvider v-slot="{ errors, valid }" name="phone" rules="required|phoneNumber">
                          <v-text-field v-model="form.phone" type="text" outlined dense color="primary" :error-messages="errors" @input="checkPhone()" />
                        </ValidationProvider> -->
                        <l-a-phone-number v-model="form.phone" :label="$t('fields.phone')" />
                      </div>
                      <p class="caption line-height-regular black--text">
                        {{ $t('you_will_redirect_to_the_app', { app: selectedTypePay.name }) }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <div class="__menu-bottom __menu-checkout">
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                  <v-btn large color="primary" width="100%" type="submit" form="formPay" class="text-none">
                    {{ $t('next') }}
                  </v-btn>
                </v-col>
              </div>
            </v-container>
          </v-form>
        </ValidationObserver>
      </v-sheet>
    </v-bottom-sheet>

    <v-dialog v-model="dialogCC" persistent content-class="elevation-0">
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6" lg="4" class="pa-0">
            <v-card max-width="400" class="card-material mx-auto br-8">
              <div class="d-flex grow flex-wrap">
                <div class="v-card--material__heading v-sheet">
                  <v-img :src="getImgBg(currentCardBackground)" gradient="to bottom, rgba(6, 2, 29, 0.45), rgba(6, 2, 29, 0.45)" :class="[`white--text card-flip`, { 'isFlip': isCardFlipped }]">
                    <div class="card-item__wrapper flex-column front">
                      <div class="mb-auto d-flex">
                        <div class="d-flex">
                          <img :src="getImgPng('chip')" class="card-item__chip">
                        </div>
                        <v-spacer />
                        <div class="d-flex">
                          <div class="card-item__type">
                            <transition name="fade">
                              <img v-if="getCardType" :key="getCardType" :src="getImgPng(getCardType)">
                            </transition>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-center">
                        <label>
                          <template v-if="getCardType !== 'amex'">
                            <span v-for="(n, $index) in otherCardMask" :key="$index">
                              <transition name="slide-fade-up">
                                <div v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''" class="card-item__numberItem">
                                  *
                                </div>
                                <div v-else-if="cardNumber.length > $index" :key="$index" class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }">
                                  {{ cardNumber[$index] }}
                                </div>
                                <div v-else :key="$index + 1" class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }">
                                  {{ n }}
                                </div>
                              </transition>
                            </span>
                          </template>
                          <template v-else>
                            <span v-for="(n, $index) in amexCardMask" :key="$index">
                              <transition name="slide-fade-up">
                                <div v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''" class="card-item__numberItem">
                                  *
                                </div>
                                <div v-else-if="cardNumber.length > $index" :key="$index" class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }">
                                  {{ cardNumber[$index] }}
                                </div>
                                <div v-else :key="$index + 1" class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }">
                                  {{ n }}
                                </div>
                              </transition>
                            </span>
                          </template>
                        </label>
                      </div>
                      <div class="mt-auto d-flex">
                        <v-spacer />
                        <div class="d-flex align-center flex-column" style="width: 45px;">
                          <div class="__expiredText">
                            Expires
                          </div>
                          <div class="__expiredDate">
                            <label for="cardMonth" class="card-item__dateItem">
                              <transition name="slide-fade-up">
                                <span v-if="cardMonth" :key="cardMonth">{{ cardMonth }}</span>
                                <span v-else key="2">MM</span>
                              </transition>
                            </label>
                            /
                            <label for="cardYear" class="card-item__dateItem">
                              <transition name="slide-fade-up">
                                <span v-if="cardYear" :key="cardYear">{{ String(cardYear).slice(2,4) }}</span>
                                <span v-else key="2">YY</span>
                              </transition>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-item__wrapper flex-column back">
                      <div class="mb-auto d-flex">
                        <div class="backBlack" />
                      </div>
                      <div class="d-flex justify-center body-back flex-column">
                        <div class="card-cvv">
                          CVV
                        </div>
                        <div class="card__secret">
                          <span v-for="(n, $index) in cardCVN" :key="$index">
                            *
                          </span>
                        </div>
                      </div>
                      <div class="mt-auto d-flex body-back">
                        <v-spacer />
                        <div class="d-flex">
                          <div class="card-item__type">
                            <transition name="fade">
                              <img v-if="getCardType" :key="getCardType" :src="getImgPng(getCardType)">
                            </transition>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-img>
                </div>
              </div>
              <v-card-text>
                <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                  <v-form>
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <ValidationProvider v-slot="{ errors, valid }" name="credit_card" rules="required|creditCard">
                          <v-text-field v-model="cardNumber" v-mask="generateCardNumberMask" label="Card Number" dense outlined :error-messages="errors" />
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="6" class="pt-0">
                        <v-select v-model="cardMonth" item-text="text" item-value="value" dense :items="listMonth" outlined label="Exp Month" />
                      </v-col>
                      <v-col cols="6" class="pt-0">
                        <v-select v-model="cardYear" dense :items="listYear" outlined label="Exp Year" />
                      </v-col>
                      <v-col cols="6" class="pt-0">
                        <ValidationProvider v-slot="{ errors, valid }" name="credit_card_cvn" rules="required|creditCardCVN">
                          <v-text-field
                            v-model="cardCVN"
                            v-mask="'####'"
                            maxlength="4"
                            label="CVV"
                            dense
                            outlined
                            :error-messages="errors"
                            @focus="isCardFlipped = true"
                            @blur="isCardFlipped = false"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text class="text-none" @click="closeCreditCard()">
                  {{ $t('close') }}
                </v-btn>
                <v-btn color="primary" class="text-none" @click="selectCreditCard()">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogIframe" persistent>
      <v-card>
        <v-card-text>
          <iframe
            v-if="data_xendit"
            height="450"
            width="100%"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            :src="data_xendit.payer_authentication_url"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangeShippingTime" persistent max-width="290">
      <v-card>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <h3 class="subtitle-1 font-weight-bold">
                {{ $t('select_delivery_time') }}
              </h3>
              <v-list class="list-delivery_time">
                <template v-for="(item, idx) in delivery_time">
                  <v-list-item :key="idx" :disabled="disabledShippingTime[idx]" @click="setNewShippingTime(item.ftime)">
                    <v-list-item-content>
                      <div class="font-weight-bold">
                        {{ item.ftime }}
                        <template v-if="$store.state.selected_store.delivery.unlimited_items_order === 0">
                          <span v-if="item.order_left < 6" class="soft-grey--text font-weight-light">
                            ( {{ item.order_left }} order left )
                          </span>
                        </template>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="delivery_time.length - 1 !== 0" :key="idx + 'divider'" />
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangeTakeTime" persistent max-width="290">
      <v-card>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <h3 class="subtitle-1 font-weight-bold">
                {{ $t('pickup_time') }}
              </h3>
              <div class="px-2 take_time--payment">
                <v-radio-group v-model="time" :mandatory="false" hide-details>
                  <v-radio label="Sekarang" value="now" color="primary" />
                  <v-radio label="Setengah jam ke depan" value="half_hour" color="primary" />
                  <v-radio label="Satu jam ke depan" value="one_hour" color="primary" />
                  <v-radio label="Dua jam ke depan" value="two_hour" color="primary" />
                  <v-radio label="Custom" value="custom" color="primary" />
                  <vue-timepicker
                    v-if="time === 'custom'"
                    v-model="take_time"
                    :format="format_take_time"
                    :minute-interval="15"
                    :hour-range="default_hour_range"
                    :minute-range="default_minute_range"
                    close-on-complete
                    advanced-keyboard
                    hide-clear-button
                    hide-disabled-hours
                    hide-disabled-minutes
                    placeholder="Reserve Time"
                    class="__time time-to-take"
                  />
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text class="text-none" @click="setNewTakeTime()">
            {{ $t('next') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPayAtCashier" persistent max-width="350" content-class="dialog-pay-at-cashier">
      <v-card>
        <div>
          <div style="position: relative; overflow: hidden; padding: 52px 52px 0 52px;">
            <div class="background-pay-at-cashier" />
            <div>
              <v-img src="@/assets/images/pay_at_cashier.png" :aspect-ratio="1/1" width="240" class="ma-auto" />
            </div>
          </div>
          <div class="notif-pay-at-cashier">
            {{ $t('v2.order_status_message' ) }}
          </div>
        </div>
        <div class="pb-6">
          <div class="d-flex" style="gap: 8px; max-width: 264px; margin: auto;">
            <div style="flex: 1 1 100%;">
              <v-btn color="white" block class="text-none font-weight-700" @click="dialogPayAtCashier = !dialogPayAtCashier">
                {{ $t('v2.cancel3') }}
              </v-btn>
            </div>
            <div style="flex: 1 1 100%;">
              <v-btn color="primary" block class="text-none font-weight-700" @click="pay()">
                {{ $t('next') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div class="__menu-bottom menu-full">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
        <v-btn color="primary" block x-large class="text-none" :disabled="disabled" @click="nextPay()">
          {{ $t('next') }}
        </v-btn>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import {
  delieverytimes as getDelieveryTimes
} from '@/api/setting'
import {
  getData as getDataPayment
} from '@/api/payment'
import {
  createOrder as createDataOrder,
  payOrder as payDataOrder
} from '@/api/order'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      selectedTypePay: {},
      phoneDisabled: true,
      dialogPhone: false,
      dialogCC: false,
      dialogIframe: false,
      dialogChangeShippingTime: false,
      dialogChangeTakeTime: false,
      dialogPayAtCashier: false,
      panel_payment: [0, 1],
      listMonth: [
        { id: 1, value: '01', text: 'January' },
        { id: 2, value: '02', text: 'February' },
        { id: 3, value: '03', text: 'March' },
        { id: 4, value: '04', text: 'April' },
        { id: 5, value: '05', text: 'May' },
        { id: 6, value: '06', text: 'June' },
        { id: 7, value: '07', text: 'July' },
        { id: 8, value: '08', text: 'August' },
        { id: 9, value: '09', text: 'September' },
        { id: 10, value: '10', text: 'October' },
        { id: 11, value: '11', text: 'November' },
        { id: 12, value: '12', text: 'December' }
      ],
      selectedPayment: [],
      payment: [],
      order: {},
      form: {
        payment_mode_id: 0,
        bank_code: '',
        payment_mode_code: '',
        phone: '',
        redirect_url: '',
        shipping_address: '',
        shipping_cost: 0
      },
      disabled: true,
      currentCardBackground: 1,
      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCVN: '',
      amexCardMask: '#### ###### #####',
      otherCardMask: '#### #### #### ####',
      cardNumberTemp: '',
      isCardFlipped: false,
      data_xendit: {},
      dataInCart: {},
      delivery_time: [],
      disabledShippingTime: [],
      time: '',
      take_time: {},
      format_take_time: 'HH:mm',
      default_hour_range: [],
      default_minute_range: [],
      url_id: '',
      waroenk_store: [
        'waroenkramenklaten',
        'waroenkramenmadiun',
        'waroenkramenpurwodadi',
        'waroenkramenblitar',
        'waroenkramentulungagung',
        'waroenkramenpedan',
        'waroenkramenkudus',
        'waroenkramensidareja',
        'waroenkramenponorogo',
        'waroenkramenpwt',
        'waroenkramennganjuk',
        'waroenkramenjombang',
        'waroenkramenkediri',
        'waroenkramensragen',
        'waroenkramengalmas',
        'waroenkramensolo',
        'waroenkramenkartasura',
        'waroenkramenkebumenpanjer',
        'waroenkramencimanggis',
        'waroenkramenmakassar',
        'waroenkramenkendari',
        'waroenkramentegal',
        'waroenkramenpontianak2',
        'waroenkramenbekasiagussalim',
        'waroenkramenpontianak',
        'waroenkramenbintara',
        'waroenkramenproklamasi',
        'waroenkramensamarinda2',
        'waroenkramenpurbalingga',
        'waroenkramenbalikpapan',
        'waroenkramenjatiwaringin',
        'waroenkramenpurwokertoump',
        'waroenkramensamarindataman',
        'waroenkramenbekasi',
        'waroenkramenmargonda',
        'waroenkramenkelapadua',
        'waroenkramenmeruya'
      ],
      store_not_cod: [
        'blisscafe',
        'pomebintaro',
        'yellowrendezvous',
        'cozyresidencebandung',
        'buttoncoffeeeatery',
        'wiraartha',
        'akgneo',
        'amalimelawai7282',
        'juskita',
        'malinohills',
        'suralippomall',
        'suralippomallpuri',
        'hongernih',
        'buburhayambejosmb',
        'tawacafe',
        'goyumcha',
        'kedaigoyumchaid',
        'stonehandcoffee',
        'elartecafetebet',
        'artirasacoffee',
        'cyberinkserpong'
      ],
      store_active_cod: [
        'smescofoodcourt',
        'allinolsera2',
        'seraqa'
      ]
    }
  },
  computed: {
    isTMII() {
      const tmii_outlet = this.$store.state.store_tmii
      const url = this.$store.state.url_domain
      if (tmii_outlet.indexOf(url) !== -1) {
        return true
      } else {
        return false
      }
    },
    isNotWaroenk() {
      const url = this.$store.state.url_domain
      if (this.waroenk_store.indexOf(url) !== -1) {
        return false
      } else {
        return true
      }
    },
    storeIsNotCod() {
      const url = this.$store.state.url_domain
      if (this.store_not_cod.indexOf(url) !== -1) {
        return false
      } else {
        return true
      }
    },
    isCD() {
      const index = this.payment.findIndex((e) => e.code === 'CD')
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain
      if (tmii_outlet.indexOf(url_id) !== -1) {
        return [false, null]
      } else if (index === -1) {
        return [false, null]
      } else {
        const url = this.$store.state.url_domain
        if (this.store_active_cod.indexOf(url) !== -1) {
          if (this.$store.state.selected_outlet.setting.use_pay_on_the_spot === 1) {
            return [true, index]
          } else {
            return [false, null]
          }
        } else {
          if (this.$store.state.selected_type === 'RESERVATION') {
            return [false, null]
          } else {
            if (index !== -1) {
              const selected_url_id = this.$store.state.url_domain
              if (selected_url_id === 'mastermie' && process.env.NODE_ENV === 'development') {
                return [true, index]
              } else {
                const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
                if (this.$store.state.selected_outlet.setting.use_pay_on_the_spot === 1) {
                  if (this.$store.state.selected_type === 'DELIVERY') {
                    if (auth_data.auth_by === 'GUEST') {
                      return [false, null]
                    } else {
                      if (this.dataInCart.shipping_delivery_type === 1) {
                        return [true, index]
                      } else {
                        return [false, null]
                      }
                    }
                  } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
                    if (auth_data.auth_by === 'GUEST') {
                      return [false, null]
                    } else {
                      return [true, index]
                    }
                  } else if (this.$store.state.selected_type === 'DINE-IN') {
                    if (auth_data.auth_by === 'GUEST') {
                      return [true, index]
                    } else {
                      return [true, index]
                    }
                  } else if (this.$store.state.selected_type === 'RESERVATION') {
                    if (auth_data.auth_by === 'GUEST') {
                      return [true, index]
                    } else {
                      return [true, index]
                    }
                  } else {
                    return [false, null]
                  }
                } else {
                  return [false, null]
                  // request pak ali
                  // melalui group support
                  // if (this.$store.state.selected_type === 'DELIVERY') {
                  //   return [false, null]
                  // } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
                  //   return [false, null]
                  // } else if (this.$store.state.selected_type === 'DINE-IN') {
                  //   return [true, index]
                  // } else if (this.$store.state.selected_type === 'RESERVATION') {
                  //   return [true, index]
                  // } else {
                  //   return [false, null]
                  // }
                }
              }
            } else {
              return [false, null]
            }
          }
        }
      }
    },
    isOQ() {
      const index = this.payment.findIndex((e) => e.code === 'OQ')
      if (index !== -1) {
        if (this.$store.state.selected_type === 'DELIVERY' && this.dataInCart.shipping_delivery_type === 2) {
          return [false, null]
        } else {
          if (this.payment[index].enabled) {
            return [true, index]
          } else {
            return [false, null]
          }
        }
      } else {
        return [false, null]
      }
    },
    isAS() {
      const index = this.payment.findIndex((e) => e.code === 'AS')
      if (index !== -1) {
        return [true, index]
      } else {
        return [false, null]
      }
    },
    isCC() {
      const index = this.payment.findIndex((e) => e.code === 'CC')
      if (index !== -1 && this.payment[index].enabled === 1) {
        return [true, index]
      } else {
        return [false, null]
      }
    },
    getCardType() {
      const number = this.cardNumber
      let re = new RegExp('^4')
      if (number.match(re) != null) return 'visa'

      re = new RegExp('^(34|37)')
      if (number.match(re) != null) return 'amex'

      re = new RegExp('^5[1-5]')
      if (number.match(re) != null) return 'mastercard'

      re = new RegExp('^6011')
      if (number.match(re) != null) return 'discover'

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return 'visa'
    },
    generateCardNumberMask() {
      return this.getCardType === 'amex' ? this.amexCardMask : this.otherCardMask
    },
    listYear() {
      const years = []
      var year = new Date().getFullYear()
      for (var i = 0; i < 12; i++) {
        years.push(year + i)
      }
      return years
    }
  },
  watch: {
    'form.payment_mode_id': function(newItem, oldItem) {
      if (newItem !== '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    time: function(newItem, oldItem) {
      if (newItem && newItem !== 'custom') {
        this.nextDisable = false
      } else {
        this.nextDisable = true
      }
    },
    take_time: function(newItem, oldItem) {
      if (newItem.HH !== '' && newItem.mm !== '') {
        this.nextDisable = false
      }
      const today = new Date()
      const curHr = today.getHours()
      const curMt = today.getMinutes()
      const time = curHr
      const thh = parseFloat(newItem.HH)
      const tmm = parseFloat(newItem.mm)
      if (thh === time && curMt > tmm) {
        if (!isNaN(tmm)) {
          if (curMt > 45) {
            this.take_time.mm = '00'
          } else if (curMt > 30) {
            this.take_time.mm = '45'
          } else if (curMt > 15) {
            this.take_time.mm = '30'
          } else {
            this.take_time.mm = '15'
          }
        }
      }
      if (thh !== time && thh !== 23) {
        this.default_minute_range = [0, 15, 30, 45]
      } else if (thh === 23) {
        this.default_minute_range = [0, 15, 30]
      } else {
        if (curMt > 30) {
          this.default_minute_range = [45]
        } else if (curMt > 15) {
          this.default_minute_range = [30, 45]
        } else if (curMt > 0) {
          this.default_minute_range = [15, 30, 45]
        }
      }
    }
  },
  mounted() {
    this.cardNumberTemp = this.otherCardMask
    this.loadPaymentMethod()
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))) {
      this.order = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))
    } else {
      this.order = {}
    }
    const selected_type = this.$store.state.selected_type
    if (selected_type) {
      var LOCAL_DATA
      if (selected_type === 'OL-TAKE-AWAY') {
        LOCAL_DATA = { ... this.$store.state.data_cart_take_away }
      } else if (selected_type === 'DELIVERY') {
        LOCAL_DATA = { ... this.$store.state.data_cart_delivery }
      } else if (selected_type === 'RESERVATION') {
        LOCAL_DATA = { ... this.$store.state.data_cart_reservation }
      } else {
        LOCAL_DATA = { ... this.$store.state.data_cart_dinein }
      }
      if (this.$isEmpty(LOCAL_DATA)) {
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      } else {
        this.dataInCart = LOCAL_DATA
      }
    } else {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }
  },
  methods: {
    setNewTakeTime() {
      this.dialogChangeTakeTime = false
    },
    setNewShippingTime(time) {
      this.dialogChangeShippingTime = false
      this.form.shipping_time = time
    },
    defaultTimeRange() {
      const today = new Date()
      const curHr = today.getHours()
      const curMt = today.getMinutes()
      if (curMt > 45) {
        for (var i = (curHr + 1); i < 24; i++) {
          this.default_hour_range.push(i)
        }
      } else {
        for (var x = curHr; x < 24; x++) {
          this.default_hour_range.push(x)
        }
      }
      if (curHr !== 23) {
        if (curMt > 45) {
          this.default_minute_range = [0, 15, 30, 45]
        } else if (curMt > 30) {
          this.default_minute_range = [45]
        } else if (curMt > 15) {
          this.default_minute_range = [30, 45]
        } else if (curMt > 0) {
          this.default_minute_range = [15, 30, 45]
        }
      }
    },
    async loadShippingTime() {
      const today = new Date()
      const curDay = today.getDay() + 1
      try {
        const { data } = await getDelieveryTimes(curDay)
        this.$store.state.loading_axios = false
        this.delivery_time = data.data.times
        for (var i = 0; i < this.delivery_time.length; i++) {
          if (this.$store.state.selected_store.delivery.unlimited_items_order === 0) {
            if (this.delivery_time[i].order_left === 0 || this.delivery_time[i].time_has_passed === 1) {
              this.disabledShippingTime[i] = true
            } else {
              this.disabledShippingTime[i] = false
            }
          } else {
            if (this.delivery_time[i].time_has_passed === 1) {
              this.disabledShippingTime[i] = true
            } else {
              this.disabledShippingTime[i] = false
            }
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async loadPaymentMethod() {
      try {
        let params = {}

        if (this.$store.state.selected_type === 'DINE-IN') {
          params = {
            remark: 'OL-DINE-IN'
          }
        }

        const { data } = await getDataPayment(params)
        this.$store.state.loading_axios = false
        this.payment = data.data
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'checkout' }).catch(() => {})
    },
    getImgPng(payment) {
      var images = require.context('@/assets/images/', false, /\.png$/)
      return images('./' + payment + '.png')
    },
    getImgBg(cc) {
      var images = require.context('@/assets/images/cc/', false, /\.jpeg$/)
      return images('./' + cc + '.jpeg')
    },
    async pay() {
      this.disabled = true
      if (this.dialogPhone === true) {
        this.dialogPhone = false
      }
      var baseDomain = window.location.href
      if (this.form.payment_mode_code === 'CD' || this.form.payment_mode_code === 'BT' || this.form.payment_mode_code === 'OQ') {
        delete this.form.phone
        delete this.form.redirect_url
      } else if (this.form.payment_mode_code === 'LINKAJA' || this.form.payment_mode_code === 'ShopeePay') {
        this.form.redirect_url = baseDomain + '/check'
      } else if (this.form.payment_mode_code === 'OVO') {
        delete this.form.redirect_url
      } else if (this.form.payment_mode_code === 'DANA') {
        delete this.form.phone
        this.form.redirect_url = baseDomain + '/check'
      } else if (this.form.payment_mode_id === 43) {
        const _hostname = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : window.location.hostname
        this.form.redirect_url = _hostname + '/account/order'
      }

      delete this.form.payment_mode_code

      if (this.$store.state.selected_type !== 'DELIVERY') {
        delete this.form.shipping_address
        delete this.form.shipping_cost
      }
      const selected_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type'))
      this.dataInCart.remark = selected_type
      this.$set(this.dataInCart, 'payment', this.form)
      try {
        var result = await createDataOrder(this.dataInCart)
        this.$store.state.loading_axios = false
        const { data } = result
        this.$store.dispatch('create_order', data.data)
        if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.no_auth_dinein) {
          this.$store.dispatch('create_history_order', data.data)
        }
        if (data.data.payment_mode_id === 10) {
          if (data.data.status === 'X') {
            this.$router.push({ name: 'order_failed' }).catch(() => {})
          } else {
            this.$router.push({ name: 'order_success' }).catch(() => {})
          }
        } else {
          if (data.data.payment_log) {
            if (data.data.payment_log.payment_source === 'VIRTUAL-ACCOUNT') {
              this.$router.push({ name: 'va_order' }).catch(() => {})
            } else if (data.data.payment_log.payment_type === 'QRIS') {
              this.$router.push({ name: 'qris' }).catch(() => {})
            } else {
              if (data.data.payment_log.checkout_url) {
                window.location = data.data.payment_log.checkout_url
              } else {
                if (data.data.payment_log.global_status === 'P') {
                  this.$router.push({ name: 'order_payment_pending' }).catch(() => {})
                } else if (data.data.payment_log.global_status === 'X') {
                  this.$router.push({ name: 'order_payment_failed' }).catch(() => {})
                } else if (data.data.payment_log.global_status === 'Z') {
                  this.$router.push({ name: 'order_success' }).catch(() => {})
                }
              }
            }
          } else {
            if (data.data.status === 'Z') {
              this.$router.push({ name: 'order_success' }).catch(() => {})
            } else if (data.data.status === 'X') {
              this.$router.push({ name: 'order_failed' }).catch(() => {})
            }
          }
        }
        this.resetForm()
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else if (e.statusCode === 501) {
          if (!this.$isEmpty(this.dataInCart)) {
            if (this.$store.state.selected_type === 'DELIVERY') {
              this.dialogChangeShippingTime = true
              this.loadShippingTime()
            }
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
            //  else if (this.order.remark === 'OL-TAKE-AWAY') {
            //   this.defaultTimeRange()
            //   this.dialogChangeTakeTime = true
            // }
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      this.disabled = false
    },
    selectPayment(idx, pay_item, index, parent_item = null) {
      this.selectedPayment = []
      this.$set(this.selectedPayment, idx, [index])
      this.form.payment_mode_id = pay_item.payment_id

      if (parent_item !== null) {
        if (parent_item.code !== null) {
          this.form.payment_mode_code = parent_item.code
          // if (parent_item.code === 'CC') {
          //   this.form.channel = pay_item.code
          // } else {
          //   this.form.channel = parent_item.code
          // }
        } else {
          this.form.payment_mode_code = pay_item.code
          // this.form.channel = pay_item.code
        }
      } else {
        this.form.payment_mode_code = pay_item.code
        // this.form.channel = pay_item.code
      }

      if (this.form.payment_mode_code === 'BT') {
        this.form.bank_code = pay_item.code
        // this.form.channel = pay_item.code
      } else {
        delete this.form.bank_code
      }
      this.selectedTypePay = pay_item
      // console.log(this.form.payment_mode_code)
    },
    nextPay() {
      if (this.form.payment_mode_code === 'ovo' || this.form.payment_mode_code === 'OVO' || this.form.payment_mode_code === 'LINKAJA') {
        this.dialogPhone = true
      } else if (this.form.payment_mode_code === 'CC' || this.form.payment_mode_code === 'mastercard' || this.form.payment_mode_code === 'visa' || this.form.payment_mode_code === 'jcb') {
        this.currentCardBackground = Math.floor(Math.random() * 11 + 1)
        this.dialogCC = true
      } else {
        const url_id = this.$store.state.url_domain
        const url_store_popup_pay_on_the_spot = [
          'scr1',
          'scr2',
          'seraqa'
        ]
        if (this.form.payment_mode_id === 10 && url_store_popup_pay_on_the_spot.includes(url_id) && this.$store.state.selected_type === 'DINE-IN') {
          this.dialogPayAtCashier = true
          return
        }
        return this.pay()
      }
    },
    async selectCreditCard() {
      const isValid = await this.$refs.observer.validate()
      this.cardNumber = this.cardNumber.replace(/\s+/g, '')
      if (isValid) {
        if (this.form.payment_mode_id === 43) {
          this.form.card_number = this.cardNumber
          this.form.card_month = this.cardMonth
          this.form.card_year = this.cardYear.toString()
          this.form.card_cvn = this.cardCVN
          this.pay()
        } else {
          const binCC = (this.cardNumber).substring(0, 6)
          window.Xendit.setPublishableKey(process.env.VUE_APP_XENDIT_KEY)
          this.$store.state.loading = true
          window.Xendit.card.threeDSRecommendation({
            bin_number: binCC
          }, this.check3DS)
        }
      }
    },
    check3DS(err, recommendation) {
      if (err) {
        this.$store.state.loading = false
        return false
      }
      if (recommendation.should_3ds === true) {
        this.cardNumber = this.cardNumber.replace(/\s+/g, '')
        window.Xendit.card.createToken({
          amount: this.dataInCart.total_amount,
          card_number: this.cardNumber,
          card_exp_month: this.cardMonth,
          card_exp_year: this.cardYear.toString(),
          card_cvn: this.cardCVN,
          is_multiple_use: false,
          should_authenticate: true
        }, this.xenditResponseHandler)
      } else {
        this.$store.state.show_error = true
        this.$store.state.error_message = 'For security, we only accept credit card with 3DS authentication. Please check with your credit card company for details.'
        this.$store.state.error_type = 422
      }
    },
    xenditResponseHandler(err, creditCardCharge) {
      this.$store.state.loading = false
      this.dialogIframe = false
      this.dialogCC = false
      this.data_xendit = creditCardCharge
      if (err) {
        this.$store.state.show_error = true
        this.$store.state.error_message = err.message
        this.$store.state.error_type = err.statusCode
      }
      if (creditCardCharge) {
        if (creditCardCharge.status === 'APPROVED' || creditCardCharge.status === 'VERIFIED') {
          this.displaySuccess(creditCardCharge)
        } else if (creditCardCharge.status === 'IN_REVIEW') {
          this.dialogIframe = true
        } else if (creditCardCharge.status === 'FRAUD') {
          this.displayError(creditCardCharge)
        } else if (creditCardCharge.status === 'FAILED') {
          this.displayError(creditCardCharge)
        }
      }
    },
    async displaySuccess(creditCardCharge) {
      this.dialogIframe = false
      const form = {
        payment_mode_id: this.form.payment_mode_id,
        cc_id: creditCardCharge.id,
        cc_authentication_id: creditCardCharge.authentication_id
      }

      const selected_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type'))
      this.dataInCart.remark = selected_type
      this.$set(this.dataInCart, 'payment', form)

      this.$store.state.loading = true
      try {
        var result
        if (this.$isEmpty(this.order)) {
          result = await createDataOrder(this.dataInCart)
        } else {
          result = await payDataOrder(this.order.id, this.form)
        }
        this.$store.state.loading_axios = false
        const { data } = result
        this.$store.dispatch('create_order', data.data)
        if (this.$store.state.selected_type === 'DINE-IN' && this.$store.state.selected_outlet.setting.no_auth_dinein) {
          this.$store.dispatch('create_history_order', data.data)
        }
        if (data.data.payment_log) {
          if (data.data.payment_log.payment_source === 'VIRTUAL-ACCOUNT') {
            this.$router.push({ name: 'va_order' }).catch(() => {})
          } else {
            if (data.data.payment_log.checkout_url) {
              window.location = data.data.payment_log.checkout_url
            } else {
              if (data.data.payment_log.global_status === 'P') {
                this.$router.push({ name: 'order_payment_pending' }).catch(() => {})
              } else if (data.data.payment_log.global_status === 'X') {
                this.$router.push({ name: 'order_payment_failed' }).catch(() => {})
              } else if (data.data.payment_log.global_status === 'Z') {
                this.$router.push({ name: 'order_success' }).catch(() => {})
              }
            }
          }
        } else {
          if (data.data.status === 'Z') {
            this.$router.push({ name: 'order_success' }).catch(() => {})
          } else if (data.data.status === 'X') {
            this.$router.push({ name: 'order_failed' }).catch(() => {})
          }
        }
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else if (e.statusCode === 501) {
          if (!this.$isEmpty(this.order)) {
            if (this.$store.state.selected_type === 'DELIVERY') {
              this.dialogChangeShippingTime = true
              this.loadShippingTime()
            }
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
            //  else if (this.order.remark === 'OL-TAKE-AWAY') {
            //   this.defaultTimeRange()
            //   this.dialogChangeTakeTime = true
            // }
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      this.$store.state.loading = false
      this.resetForm()
    },
    displayError(e) {
      this.$store.state.show_error = true
      this.$store.state.error_message = e.string
      this.$store.state.error_type = e.statusCode
      this.dialogIframe = false
    },
    closeCreditCard() {
      this.dialogCC = false
      this.cardNumber = ''
      this.cardMonth = ''
      this.cardYear = ''
      this.cardCVN = ''
      this.$nextTick(() => this.$refs.observer.reset())
      this.form = {}
      delete this.form.payment_mode_id
      // delete this.form.channel
      delete this.form.card_number
      delete this.form.card_month
      delete this.form.card_year
      delete this.form.card_cvn
    },
    closeDialogPhone() {
      this.dialogPhone = false
      this.form.phone = ''
      this.$nextTick(() => this.$refs.observerEWallet.reset())
    },
    resetForm() {
      this.selectedPayment = []
      this.dialogPhone = false
      this.dialogCC = false
      this.form.payment_mode_id = 0
      this.form.bank_code = ''
      this.form.payment_mode_code = ''
      this.form.phone = ''
      this.form.redirect_url = ''
      this.form.shipping_address = ''
      this.form.shipping_cost = 0
      this.cardNumber = ''
      this.cardMonth = ''
      this.cardYear = ''
      this.cardCVN = ''
      // this.$refs.observerEWallet.reset()
      // this.$refs.observer.reset()
    },
    async payLinkAja() {
      const isValid = await this.$refs.observerEWallet.validate()
      if (isValid) {
        await this.pay()
      }
    },
    checkDisabledPayment(item) {
      if (this.isTMII) {
        if (item.code === 'CD' || item.code === 'CC' || item.code === 'OQ' || item.code === 'AS' || item.name === 'E-Wallet') {
          return false
        } else {
          return true
        }
      } else {
        if (item.code === 'CD' || item.code === 'CC' || item.code === 'OQ' || item.code === 'AS') {
          return false
        } else {
          return true
        }
      }
    },
    vaCheckEnable(child, code) {
      // disable bca request nabila karena error bca 6 september 13.55
      if (child.code === 'BCA') {
        return true
      } else {
        if (child.enabled === 1) {
          if (code === 'BT') {
            if (this.$store.state.selected_outlet.setting.active_minimum_payment_amount_va) {
              if ((this.$store.state.selected_type === 'DELIVERY' && this.dataInCart.shipping_delivery_type === 2 ? this.dataInCart.total_amount_without_shipping : this.dataInCart.total_amount) < Number(this.$store.state.selected_outlet.setting.minimum_payment_amount_va)) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          } else {
            if (child.code === 'ShopeePay' && !this.$vuetify.breakpoint.smAndDown) {
              return true
            } else {
              return false
            }
          }
        } else {
          return true
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.card-material{
  margin-top: 50px;
  padding: 16px;
  padding-top: 0px;
}
.v-card--material__heading {
  position: relative;
  -webkit-transition: .3s ease;
  transition: .3s ease;
  z-index: 1;
  width: 100%;
}
.v-card .v-card--material__heading {
  top: -40px;
}
.v-sheet{
  border-radius: 4px;
}
.v-card--material__heading .v-image{
  border-radius: 15px;
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.v-card .v-card__text{
  padding-top: 0px;
}
.card-item__wrapper{
  display: flex;
  flex: 1 1 auto;
  padding: 25px 15px;
  height: 100%;
}
.card-item__chip{
  width: auto;
  height: 35px;
}
.card-item__type{
  max-width: 70px;
  max-height: 35px;
  height: auto;
  position: relative;
  overflow: hidden;
}
.card-item__type img{
  height: 100%;
  width:100%;
  object-fit: contain;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}
.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}
.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}
.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}
.card-item__number {
  padding: 10px 15px;
  cursor: pointer;
}
.card-item__numberItem {
  line-height: 1;
  font-weight: 500;
  font-size: 18px;
  width: 12px;
  display: inline-block;
}
.card-flip{
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.isFlip{
  transform: rotateY(180deg);
}
.card-flip.isFlip .card-item__wrapper.front {
  display: none;
}
.card-item__wrapper.back{
  display: none;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.card-item__wrapper.back .card-item__type{
  max-height: 25px;
}
.card-flip.isFlip .card-item__wrapper.back{
  display: flex;
  transform: rotateY(180deg);
}
.__expiredText{
  opacity: 0.7;
}
.__expiredDate, .__expiredText{
  font-size: 10px;
}
.backBlack{
  height: 35px;
  width: 100%;
  background-color: #000;
}
.card__secret{
  height: 30px;
  background: #fff;
  width: 100%;
  padding-right: 10px;
  color: #1a3b5d;
  font-size: 18px;
  border-radius: 4px;
  -webkit-box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
  box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.card__secret span{
  font-size: 12px;
}
.body-back{
  padding: 0 15px;
}
.card-cvv{
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  padding: 2px 10px;
}
</style>
